<template>
  <div class="layout" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div style="position: fixed; left: 60px; top: 17px; z-index: 10000;">
      <el-button type="info" icon="el-icon-caret-left" size="small" @click="goback">返回</el-button>
    </div>
    <div style="margin-bottom: 15px; min-width: 800px;">
      <el-radio-group v-model="broadcastType" fill="#666" @change="getTab">
        <el-radio-button label="單發">交易推播訊息</el-radio-button>
        <el-radio-button label="群發">群發廣播</el-radio-button>
        <el-radio-button label="排程">排程群發廣播</el-radio-button>
        <el-radio-button label="標籤">分眾標籤</el-radio-button>
        <el-radio-button label="已排">已排程的廣播</el-radio-button>
        <el-radio-button label="記錄">廣播記錄查詢</el-radio-button>
      </el-radio-group>
    </div>
    <el-row>
      <!-- 標籤 -->
      <el-col :span="24" style="margin-bottom: 20px;" v-if="broadcastType === '標籤'">
        <div class="msg">
          <tag :TagList="TagList"
            :userTagsBox="userTagsBox"
            :service="service"
            :limitTag="limitTag"
            :auth="auth"
            @getTags="getPageTag"/>
        </div>
      </el-col>
      <!-- 排程中 -->
      <el-col :span="24" style="margin-bottom: 20px;" v-if="broadcastType === '已排'">
        <scheduleRecord/>
      </el-col>
      <!-- 記錄 -->
      <el-col :span="24" style="margin-bottom: 20px;" v-if="broadcastType === '記錄'">
        <broadcastRecord :pointRecord="pointRecord"/>
      </el-col>
      <!-- 群發 -->
      <el-col :span="24" style="margin-bottom: 20px;" v-if="broadcastType === '群發' || broadcastType === '排程'">
        <broadcast :cardTable="cardTable"
          :TagList="TagList"
          :memberNum="memberNum"
          :tagNum="tagNum"
          :userTagsBox="userTagsBox"
          :blueMenu="blueMenu"
          :broadcastType="broadcastType"
          :blueMenuData="blueMenuData"
          :allSub="allSub"/>
      </el-col>
      <!-- 單一訊息 -->
      <el-col :span="24" v-if="broadcastType === '單發'">
        <comsume :AllMsg="AllMsg"/>
      </el-col>
    </el-row>
    <div style="height: 60px;"/>
    <div style="position: fixed; bottom: 10px; left: 20px; text-align: left;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import XLSX                       from 'xlsx';
import tag                        from './broadcast/tag';
import broadcast                  from './broadcast/broadcast';
import comsume                    from './broadcast/comsume';
import broadcastRecord            from './broadcast/broadcastRecord';
import scheduleRecord             from './broadcast/scheduleRecord';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      pageLoading: false,
      allSub: '',
      memberNum: '',
      tagNum: '',
      limitTag: '',
      pageAdmin: '',
      radio: '文字訊息',
      recordType: '1',
      finalCheck: false,
      isLoading: false,
      nowTag: '',
      phone: '',
      broadcastType: '單發',
      showDetail: false,
      removeCheck: false,
      sync: false,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      userDetail: {
        phone: '',
        name: '',
        tags: [],
        token: ''
      },
      broadcastData: {
        Service: this.$route.params.service,
        Auth: this.$route.params.id,
        CardValue: '',
        CardID: [],
        CardName: '',
        Tag: null,
        Reply: '公版主選單',
        scheduleTime: ''
      },
      cardTable2: [
        {
          name: '載入中...',
          cards: []
        }
      ],
      cardTable: [
        {
          name: '載入中...',
          cards: []
        }
      ],
      selectedYear: '2020',
      years: ['2019', '2020'], 
      pointRecord: {
        2019: [],
        2020: []
      },
      blueMenuData: [],
      blueMenu: ['公版主選單'],
      userTagsBox: ['載入中...'],
      TagList: [],
      TagUser: [
        ['12345', { Name: '載入中...', Phone: '載入中...' }]
      ],
      AllMsg: [
        {
          type: 'Comsume',
          title: '消費成功訊息',
          text: '',
          hint: '@ELS_ACC_POINT = 用戶剩餘點數',
          open: true
        },
        {
          type: 'Exchange',
          title: '兌點成功訊息',
          text: '',
          hint: '@ELS_CHARGE = 已兌換點數\n@ELS_RESTPOINT = 用戶剩餘點數',
          open: true
        },
        {
          type: 'Send',
          title: '贈點成功訊息',
          text: '',
          hint: '@ELS_CHARGE = 已贈送點數\n@ELS_REMAIN = 用戶剩餘點數',
          open: true
        },
        {
          type: 'Undo',
          title: '取消消費訊息',
          text: '',
          hint: '@ELS_REMAIN = 用戶剩餘點數',
          open: true
        },
        {
          type: 'Refund',
          title: '退款成功訊息',
          text: '',
          open: true,
          hint: '@ELS_REMAIN = 用戶剩餘點數'
        },
        {
          type: 'UnExchange',
          title: '取消兌點訊息',
          text: '',
          open: true,
          hint: '@ELS_REMAIN = 用戶剩餘點數'
        }
      ],
      customStyle: {
        flashMessageStyle: {
          background: "linear-gradient(#e66465, #9198e5)"
        },
      }
    };
  },
  components: {
    tag, broadcast, comsume, broadcastRecord, scheduleRecord
  },
  mounted() {
    this.getMemberData();
    this.getAllMessage();
    this.checkUsableCards(this.service);
    this.getPointList();
    this.checkWhiteList({ auth: this.auth, type: 'tagNum' }).then((resp) => {
      if (resp && resp.Detail) {
        this.limitTag = resp.Detail.num;
      }
    })
    if (this.service === 'FB') {
      this.getBroadcastNum();
      this.getBlue();
    }
    else {
      this.getBlueEach(this.auth).then((res) => {
        this.blueMenu = Object.keys(res);
        this.searchMenu();
      })
    }
  },
  computed: {
    ...mapGetters({
      menus: 'menus',
      workFlows: 'workFlows'
    })
  },
  methods: {
    ...mapActions({
      getAllWorkFlow: 'getAllWorkFlow',
      createTags: 'createTags',
      checkWhiteList: 'checkWhiteList',
      getBroadcastPoint: 'getBroadcastPoint',
      broadcast: 'broadcast',
      getBlueFB: 'getBlue',
      getMemberNum: 'getMemberNum',
      getBlueMenu: 'getBlueMenu',
      getPageAdmin: 'getPageAdmin',
      getBroadcastDetail: 'getBroadcastDetail',
      getBlueMenuBeta: 'getBlueMenuBeta',
      getBlueEach: 'getBlueEach',
      getAllTags: 'getAllTags',
      queryMenuLINE: 'queryMenuLINE',
      getAllWorkFlowLINE: 'getAllWorkFlowLINE',
      getSuccessMessage: 'getSuccessMessage',
      setSuccessMessage: 'setSuccessMessage'
    }),
    getTab(type) {
      if (type === '標籤' || type === '群發' || type === '排程') {
        if (this.TagList.length < 1) {
          this.getTags();
        }
      }
    },
    enter(val) {
      this.nowTag = val;
    },
    leave(val) {
      this.nowTag = '';
    },
    goback() {
      this.$router.push(`/shoplist/?service=${this.service}&auth=${this.auth}`);
    },
    getPointList() {
      this.getBroadcastPoint({ service: this.service, auth: this.auth })
        .then((res) => {
          if (res.data.records) {
            let pointList = [];
            const pointArr = Object.entries(res.data.records);
            for (let i = 0; i < pointArr.length; i += 1) {
              const year   = pointArr[i][0];
              const months = Object.entries(pointArr[i][1]);
              pointList[year] = [];
              for (let e = 0; e < months.length; e += 1) {
                pointList[year].push({
                  month: months[e][0],
                  count: months[e][1]
                })
              }
            }
            this.pointRecord = pointList;
          }
        })
    },
    checkUsableCards(service) {
      const workFlowList = this.workFlows[this.auth];
      if (service === 'FB') {
        if (workFlowList) {
          this.getAllWorkFlowLocal(workFlowList);
        }
        else {
          this.getAllWorkFlow(this.auth).then((res) => {
            if (res) {
              this.getAllWorkFlowLocal(res);
            }
          })
        }
      }
      else {
        if (workFlowList) {
          this.getAllWorkFlowLocalLINE(workFlowList);
        }
        else {
          this.getAllWorkFlowLINE(this.auth).then((res) => {
            if (res) {
              this.getAllWorkFlowLocalLINE(res);
            }
          })
        }
      }
    },
    getTime(time) {
      return new Date(time).toLocaleString();
    },
    getBlue() {
      this.getBlueFB(this.auth).then((res) => {
        this.blueMenu = res.data;
        this.searchMenu();
      })
    },
    getMemberData() {
      this.getMemberNum({ service: this.service, auth: this.auth })
        .then((res) => {
          this.memberNum = res.Data.total;
          this.tagNum = res.Data.total;
        })
    },
    getBroadcastNum() {
      this.getPageAdmin({ auth: this.auth }).then((res) => {
        this.pageAdmin = res.UserID;
        this.getBroadcastDetail({ pageAdmin: this.pageAdmin, auth: this.auth })
          .then((resp) => {
            this.allSub = resp.MonthlyQuota + resp.BonusQuota;
          })
      })
    },
    getPageTag() {
      this.pageLoading = true;
      this.getAllTags({ service: this.service, auth: this.auth })
        .then((res) => {
          this.pageLoading = false;
          if (res && res.Tags.length > 0) {
            this.userTagsBox = res.Tags.map(el => el[0]).concat('無');
            this.TagList = res.Tags;
          }
          else {
            this.userTagsBox = [];
          }
        })
    },
    getTags() {
      this.getAllTags({ service: this.service, auth: this.auth })
        .then((res) => {
          if (res && res.Tags.length > 0) {
            this.userTagsBox = res.Tags.map(el => el[0]).concat('無');
            this.TagList = res.Tags;
          }
          else {
            this.userTagsBox = [];
          }
        })
    },
    searchMenu() {
      this.blueMenuData = [];
      if (this.service === 'FB') {
        if (this.menus[this.auth]) {
          const menuData = this.broadcastData.Reply ? this.menus[this.auth][this.broadcastData.Reply] : this.menus[this.auth]['公版主選單'];
          this.blueMenuData = menuData.edit.Menu;
        }
        else {
          this.getBlueMenuBeta(this.auth).then(() => {
            const menuData = this.broadcastData.Reply ? this.menus[this.auth][this.broadcastData.Reply] : this.menus[this.auth]['公版主選單'];
            this.blueMenuData = menuData.edit.Menu;
          })
        }
      }
      else {
        const selectedMenu = this.broadcastData.Reply ? this.broadcastData.Reply : '公版主選單';
        if (this.menus[this.auth]) {
          this.blueMenuData = Object.values(this.menus[this.auth][selectedMenu].quickReply.items).map(el => el.action.text);
        }
        else {
          this.queryMenuLINE(this.auth).then(() => {
            this.blueMenuData = Object.values(this.menus[this.auth][selectedMenu].quickReply.items).map(el => el.action.text);
          })
        }
      }
    },
    getAllMessage() {
      this.pageLoading = true;
      this.AllMsg.map((el, idx) => {
        this.getSuccessMessage({ service: this.service, auth: this.auth, type: el.type })
          .then((res) => {
            this.pageLoading = false;
            if (res && res !== 'null') {
              this.AllMsg[idx].text = res;
            }
            else {
              this.AllMsg[idx].text = '';
              this.AllMsg[idx].open = false;
            }
          });
      });
    },
    getType(res) {
      if (res.data.Content) {
        if (res.data.Content.template) {
          if (res.data.Content.template.type === 'carousel') {
            return 'Carousel template';
          }
          if (res.data.Content.template.type === 'image_carousel') {
            return 'image_carousel';
          }
        }
        else {
          return res.data.Content.type;
        }
      }
      if (res.data.CardType) {
        return 'flex_01';
      }
    },
    getTagNum(val) {
      const selectedTag = this.TagList.filter(el => el[0] === val)[0];
      if (selectedTag) {
        this.tagNum = selectedTag[1].totalRecipients;
      }
      else {
        this.tagNum = this.memberNum;
      }
    },
    // 取得卡片類型 LINE
    getCardsTypeLINE(payload) {
      const apiUrl = 'https://api-linebiz.eilis-ai.com/app/DBDataInquire';
      return this.axios.post(apiUrl, payload)
        .then(response => ({
          content: response.data,
          idx: (payload !== undefined) ? payload.idx : 0,
          type: this.getType(response),
        }));
    },
    // 取得卡片類型 FB
    getCardsType(payload) {
      const apiUrl = `https://api.eilis-ai.com/functional/GetPayload`;
      return this.axios.post(apiUrl, payload)
        .then(response => ({
          idx: payload.idx,
          type: response.data.Type,
        }));
    },
    correctTypeLINE(data, idx, workflowName) {
      let type1 = '';
      if (data.type === 'text') {
        type1 = '文字訊息'
      }
      else if (data.type === 'image') {
        type1 = '圖片訊息'
      }
      else if (data.type === 'audio') {
        type1 = '語音訊息'
      }
      else if (data.type === 'image_carousel') {
        type1 = '圖片卡片'
      }
      else if (data.type === 'flex' && data.content.CardType === 'flex_01') {
        type1 = '文字卡片'
      }
      else if (data.type === 'flex' && data.content.CardType !== 'flex_01') {
        type1 = '橫向卡片'
      }
      else {
        type1 = '直向卡片'
      }
      workflowName[idx].type = type1;
      if (idx === workflowName.length - 1) {
        this.cardTable = workflowName;
        this.cardTable2 = this.cardTable.filter(ca => ca.type === this.radio);
      }
    },
    getAllWorkFlowLocalLINE(res) {
      const workflowName = [];
      const cardArray = Object.keys(res);
      for (let i = 0; i < cardArray.length; i += 1) {
        workflowName[i] = {
          name: Object.values(res)[i].KeyWord[0].replace('@$@', '').replace('#&#',''),
          cards: [Object.values(res)[i].CardID],
          type: '',
        };
      }
      this.cardTable = workflowName;
      workflowName.map((el, idx) => {
        this.getCardsTypeLINE({
          Path: 'Eilis-Clients/',
          ChildPath: `${this.auth}/Card/${el.cards[0]}`,
          idx,
        }).then((resp) => {
          this.correctTypeLINE(resp, idx, workflowName);
        })
      })
    },
    correctTypeFB(type, idx) {
      let type1 = '';
      switch (type) {
        case 'Message'    : type1 = '文字訊息'; break;
        case 'Image'      : type1 = '圖片訊息'; break;
        case 'Audio'      : type1 = '語音訊息'; break;
        case 'MessageCard': type1 = '文字卡片'; break;
        case 'WebCard'    : type1 = '網頁卡片'; break;
        case 'BoxCard'    : type1 = '橫向卡片'; break;
        default           : type1 = '直向卡片'; break;
      }
      this.$set(this.cardTable[idx], 'type', type1);
      if (idx === this.cardTable.length - 1) {
        this.cardTable2 = this.cardTable.filter(ca => ca.type === this.radio);
      }
    },
    // 取得臉書卡片
    getAllWorkFlowLocal(res) {
      let workflowName = [];
      const cardArray = Object.keys(res);
      for (let i = 0; i < cardArray.length; i += 1) {
        workflowName[i] = {
          name: Object.keys(res)[i].replace('@#@', '').replace('@$@', ''),
          cards: Object.values(res)[i].Cards,
          type: '',
          showType: Object.values(res)[i].ShowType
        }
      }
      this.cardTable = [];
      for (let e = 0; e < workflowName.length; e += 1) {
        const workFlowName = workflowName[e].name;
        if (workFlowName !== 'OtherCards' && this.cardTable.map(cr => cr.name).indexOf(workFlowName) === -1) {
          this.cardTable.push(workflowName[e]);
        }
      }
      // workflowName.filter(el => el.name !== 'OtherCards');
      this.cardTable.map((el, idx) => {
        if (el.showType) {
          this.correctTypeFB(el.showType, idx);
        }
        else {
          this.getCardsType({
            PageID: this.auth,
            CardID: el.cards.join(),
            idx
          }).then((resp) => {
            this.correctTypeFB(resp.type, idx);
          })
        }
      })
    },
    changeCardGroup() {
      this.broadcastData.CardValue = '';
      this.cardTable2 = this.cardTable.filter(el => el.type === this.radio);
    }
  }
}
</script>

<style scoped>
.textarea {
  text-align: left;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  border-radius: 7px;
}
.selector {
  border: 1px solid #cfcfcf;
  margin-right: -1px;
  padding: 15px 11px;
  line-height: 47px;
}
.blue_btn {
  background: rgba(48, 117, 229, 0.2);
  border: 1px solid rgba(48, 117, 229, 1);
  color: rgba(48, 117, 229, 1);
  transform: translateY(-3px);
  display: inline-block;
  padding: 2px 15px;
  font-size: 16px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 5px;
}
.blue_btn:hover {
  background: rgba(255, 28, 28, 0.2);
  border: 1px solid rgba(255, 28, 28, 1);
  color: rgba(255, 28, 28, 1);
  transform: translateY(-3px);
  display: inline-block;
  padding: 2px 15px;
  font-size: 16px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 5px;
}
.msg {
  margin: 0 auto;
  background-color: #fff;
  padding: 15px;
  border-radius: 5px;
  width: 89%;
  /* min-width: 750px; */
  max-width: 850px;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
}
.work {
  font-size: 17px;
}
.layout {
  min-width: 100%;
  max-width: 100%;
  margin-left: 0!important;
  flex: 1 1 100%;
  padding: 30px;
  padding-top: 80px;
}
.card {
  border-radius: 3px;
  background-color: #999;
  padding: 15px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
}

</style>